import { render, staticRenderFns } from "./ShippingParcelNumberTemplate.vue?vue&type=template&id=2c22056d&scoped=true&"
import script from "./ShippingParcelNumberTemplate.vue?vue&type=script&lang=js&"
export * from "./ShippingParcelNumberTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c22056d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c22056d')) {
      api.createRecord('2c22056d', component.options)
    } else {
      api.reload('2c22056d', component.options)
    }
    module.hot.accept("./ShippingParcelNumberTemplate.vue?vue&type=template&id=2c22056d&scoped=true&", function () {
      api.rerender('2c22056d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Papers/pages/Paper/components/Templates/ShippingParcelNumberTemplate.vue"
export default component.exports